import Link from "next/link"
import React, { HTMLAttributes, memo } from "react"

type NextLinkProps = HTMLAttributes<HTMLAnchorElement> & {
  href: string
  passHref?: boolean
  openInNewTab?: boolean
  children: React.ReactNode
  noScrollToTop?: boolean
  ariaLabel?: string
}

const NextLink: React.FunctionComponent<NextLinkProps> = ({
  href,
  passHref,
  children,
  openInNewTab = false,
  noScrollToTop = false,
  ariaLabel,
  ...props
}) => {
  // const { asPath } = useRouter()
  // const idx = asPath.indexOf("?")
  // const search = idx >= 0 ? asPath.slice(idx) : undefined
  // const link: UrlObject = {
  //   pathname: href,
  //   // search
  //  }

  return (
    <Link href={href} passHref scroll={!noScrollToTop}>
      {openInNewTab ? (
        <a target="_blank" rel="noreferrer" {...props} aria-label={ariaLabel}>
          {children}
        </a>
      ) : passHref ? (
        children
      ) : (
        <a {...props} aria-label={ariaLabel}>
          {children}
        </a>
      )}
    </Link>
  )
}

export default memo(NextLink)
